import type { KeyboardEvent as ReactKeyboardEvent } from 'react'

// Safari fires the keydown that confirms an IME candidate after compositionend, so
// isComposing is already false and only the legacy 229 keyCode identifies it.
const IME_PROCESS_KEY_CODE = 229

// keyCode is deprecated, but nothing standard replaces it for the Safari case above.
interface LegacyKeyCodeEvent {
  readonly keyCode: number
}

/**
 * Whether a key event belongs to an IME (e.g. Japanese, Korean or Chinese input) that is
 * composing text, so keys like Enter, Escape and the arrows must be left to the IME.
 *
 * `Input`, `TextArea`, `TextAreaOnly` and `BorderlessTextAreaOnly` already skip `onKeyDown`
 * while composing; call this for key handlers they don't own, e.g. on a wrapper or window.
 */
function isImeComposing(event: KeyboardEvent | Pick<ReactKeyboardEvent, 'nativeEvent'>): boolean {
  const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event
  const legacyEvent: LegacyKeyCodeEvent = nativeEvent
  return nativeEvent.isComposing || legacyEvent.keyCode === IME_PROCESS_KEY_CODE
}

export default isImeComposing
